import { gql } from '@apollo/client';

const GET_CHARGING_SESSIONS = {
  query: gql`
    query GetChargingSessions(
      $getChargingSessionsId: String
      $connectorId: String
      $active: Boolean
      $providerId: String
      $plate: String
      $limit: Int
      $offset: Int
    ) {
      getChargingSessions(
        id: $getChargingSessionsId
        connectorId: $connectorId
        active: $active
        providerId: $providerId
        plate: $plate
        limit: $limit
        offset: $offset
      ) {
        instances {
          _id
          connectorId
          active
          status
          vehicleVin
          vehiclePlate
          providerSessionId
          providerId
          powerDelivered
          startDate
          endDate
          initialSoc
          finalSoc
        }
      }
    }
  `,
  policies: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
    pollInterval: 5000,
  },
};

export default GET_CHARGING_SESSIONS;
